/**
 * Hides ConvertCart IntelliSearch "N in Stock" badges inside .cc-search-tags.
 * Sale, Sold out, and other labels are not affected.
 */
(function hideConvertCartSearchStockTags() {
  function isRemainingStockBadge(element) {
    if (element.classList.contains('cc-search-soldout-product')) return false;
    const text = element.textContent.replace(/\s+/g, ' ').trim();
    return /^\d+ in stock$/i.test(text);
  }

  function hideStockTags(root = document) {
    const containers = root.matches?.('.cc-search-tags')
      ? [root]
      : [...root.querySelectorAll('.cc-search-tags')];

    containers.forEach((tagsContainer) => {
      tagsContainer.querySelectorAll(':scope > div').forEach((tag) => {
        if (!isRemainingStockBadge(tag)) return;
        tag.classList.add('cc-search-stock-tag--hidden');
        tag.style.display = 'none';
      });
    });
  }

  hideStockTags();

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;
        if (node.matches?.('.cc-search-tags')) {
          hideStockTags(node);
        } else if (node.querySelector?.('.cc-search-tags')) {
          hideStockTags(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
